import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

function initializeVideoListSplide() {
  const buttonElement = document.querySelector('.js-videoListButton');
  const panelElement = document.querySelector('.js-videoListPanel');

  if (!buttonElement || !panelElement) return;

  const startIndex = getStartIndex(panelElement);

  const buttonSplide = createButtonSplide(buttonElement, startIndex);
  const panelSplide = createPanelSplide(panelElement, startIndex);

  panelSplide.on('active', (activeSlide) => {
    const slide = activeSlide.slide;
    const track = panelSplide.Components.Elements.track;
    track.style.height = `${slide.offsetHeight}px`;
  });

  panelSplide.sync(buttonSplide);
  buttonSplide.mount();
  panelSplide.mount();

  setupNextButtons(panelSplide);
  setUpCategoryModal(panelSplide);
}

function createButtonSplide(element, startIndex) {
  return new Splide(element, {
    type: 'fade',
    autoWidth: false,
    width: '100%',
    pagination: false,
    speed: 250,
    arrows: false,
    drag: false,
    focus: 0,
    updateOnMove: true,
    start: startIndex,
  });
}

function createPanelSplide(element, startIndex) {
  return new Splide(element, {
    pagination: false,
    arrows: false,
    perMove: 1,
    updateOnMove: true,
    autoHeight: true,
    flickMaxPages: 1,
    start: startIndex,
  });
}

function setupNextButtons(splide) {
  const nextButtons = document.querySelectorAll('.js-videoListNextButton');
  nextButtons.forEach((button) => {
    button.addEventListener('click', () => {
      splide.index >= splide.length - 1 ? splide.go(0) : splide.go('+');
    });
  });
}

function getStartIndex(panelElement) {
  const videoHistoryArea = document.querySelector('.js-videoHistory');

  if (!videoHistoryArea) return 0;

  const lastHref = localStorage.getItem('lastHref');
  if (!lastHref) {
    return 0;
  }

  const lastCategory = localStorage.getItem('lastCategory');
  let startIndex = 0;

  // 含まれるslideのうち、data-categoryがlastCategoryと一致するものを探す
  const slides = panelElement.querySelector('.js-videoListPanelList').children;
  Array.from(slides).forEach((slide, index) => {
    if (slide.dataset.category === lastCategory) {
      startIndex = index;
      return;
    }
  });

  return startIndex;
}

function setUpCategoryModal(panelSplide) {
  const modalCategoryButtons = document.querySelectorAll('.js-modalCategoryButton');
  modalCategoryButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      panelSplide.go(index);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeVideoListSplide();
});
